import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import renderComponent from 'recompose/renderComponent'
import withProps from 'recompose/withProps'
import withHandlers from 'recompose/withHandlers'
import branch from 'recompose/branch'
import compose from 'recompose/compose'

import * as PlaybookSelectors from 'app/modules/playbook/selectors'
import * as PlaybookActions from 'app/modules/playbook/actions'
import { PlaybookStatus } from 'app/modules/playbook/constants'

import { AutoSaveStatus, SaveStatus, ArchivedStatus } from './component'

const mapStateToProps = state => ({
  playbookStatus: PlaybookSelectors.status(state),
  isSaving: PlaybookSelectors.isSaving(state),
  isSaved: PlaybookSelectors.isSaved(state),
  isArchived: PlaybookSelectors.isArchived(state),
  isPlaybookChangePending: PlaybookSelectors.pendingPlaybookChanges(state),
  isOneTimeEmailPlaybook: PlaybookSelectors.getIsOneTimeEmailPlaybook(state),
  isAutosaveActive: PlaybookSelectors.isAutosaveActive(state),
  saveFailed: PlaybookSelectors.saveFailed(state),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      disablePlaybookAutosave: PlaybookActions.disablePlaybookAutosave,
      savePlaybookDraft: PlaybookActions.savePlaybookDraft,
    },
    dispatch
  ),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  branch(({ isArchived }) => isArchived, renderComponent(ArchivedStatus)),
  withProps(props => ({
    isEnabled: props.playbookStatus === PlaybookStatus.ENABLED,
  })),
  withHandlers({
    handleSavePlaybookDraft: props => () => {
      props.actions.savePlaybookDraft()
    },
  }),
  branch(({ isAutosaveActive }) => !isAutosaveActive, renderComponent(SaveStatus))
)(AutoSaveStatus)



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/SaveStatus/index.js